import { EProductWizardMode } from '@gelato-api-ui/core/e-commerce/e-product-wizard-mode.enum';

export const isEditModeForPublishedProduct = (mode: EProductWizardMode): boolean =>
  [
    EProductWizardMode.EDIT_DESIGNS,
    EProductWizardMode.EDIT_MEDIA,
    EProductWizardMode.EDIT_DETAILS,
    EProductWizardMode.EDIT_PRICES,
  ].includes(mode);
